// Helpers for calling Nhost serverless functions with the user's JWT.
// The functions live at https://<sub>.functions.<region>.nhost.run/v1/<name>.

import { nhost } from '../nhost';

const FUNCTIONS_BASE =
  `https://${import.meta.env.VITE_NHOST_SUBDOMAIN}.functions.${import.meta.env.VITE_NHOST_REGION}.nhost.run/v1`;

export async function callFunction<T = unknown>(name: string, body: unknown): Promise<T> {
  const token = nhost.auth.getAccessToken();
  const res = await fetch(`${FUNCTIONS_BASE}/${name}`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(`${name} ${res.status}: ${detail || res.statusText}`);
  }
  return (await res.json()) as T;
}

export async function translateText(
  text: string,
  targetLang: 'de' | 'en' | 'it' | 'fr',
  sourceLang?: string,
): Promise<{ translated: string; provider: string }> {
  return callFunction('translate-text', { text, targetLang, sourceLang });
}

export type CarlosMessage = { role: 'user' | 'assistant'; content: string };
export async function carlosComplete(
  messages: readonly CarlosMessage[],
  shops: readonly string[],
): Promise<{ reply: string }> {
  return callFunction('carlos-chat', { messages, shops });
}
